module.exports = {"621024100":"西华池镇","621024101":"老城镇","621024102":"太白镇","621024103":"板桥镇","621024104":"何家畔镇","621024105":"吉岘镇","621024106":"肖咀镇","621024107":"固城镇","621024202":"段家集乡","621024204":"太莪乡","621024205":"店子乡","621024208":"蒿咀铺乡"}


//////////////////
// WEBPACK FOOTER
// ./src/town/621024.json
// module id = 3082
// module chunks = 0